const FUEL_TYPES = {
    IFO_180: 'ifo180',
    IFO_380: 'ifo380',
    MGO: 'mgo',
    VLSFO: 'vlsfo',
    ULSFO: 'ulsfo',
    LSMGO: 'lsmgo',
};

export default FUEL_TYPES;



// WEBPACK FOOTER //
// ./app/constants/fuel.js